import { render, staticRenderFns } from "./testHome.vue?vue&type=template&id=44bdc4fe&scoped=true&"
import script from "./testHome.vue?vue&type=script&lang=js&"
export * from "./testHome.vue?vue&type=script&lang=js&"
import style0 from "./testHome.vue?vue&type=style&index=0&id=44bdc4fe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44bdc4fe",
  null
  
)

export default component.exports